const statuses = {
	active: 'active',
	stopped: 'stopped'
};

const locale = {
	[statuses.active]: 'активний',
	[statuses.stopped]: 'зупинений'
};

module.exports = {
	enum: statuses,
	locale: locale
};
